const RouteEnum = {
    HOME: "/",
    COMPANY_HOME: "/company",

    LOCATION: "/location",
    LOCATION_PROFILE: "/location/edit",
    LOCATION_SCHEDULE: "/location/schedule",

    AGENT: "/agent",
    AGENT_PROFILE: "/agent/edit",
    AGENT_SCHEDULE: "/agent/schedule",

    APPOINTMENT_EDIT: "/appointment/:scheduleId/edit",
    APPOINTMENT_CONFIRM: "/appointment/:scheduleId",
    APPOINTMENT_RESCHEDULE: "/appointment/:scheduleId/reschedule",
    APPOINTMENT_CANCEL: "/appointment/:scheduleId/cancel",
    APPOINTMENT_JOIN: "/appointment/:scheduleId/join",
}

export default RouteEnum;